import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import Nav from 'estimate_list/components/nav'
import Share from 'estimate_list/components/share'
import EstimateSave from 'estimate_list/components/estimate_save'


const Top = () => {
    const categoryData = useSelector(state => state.category.categoryData)
    const domain = useSelector(state => state.initial.domain)

    return (
        <Style>
            {categoryData.length > 0 ? <Nav /> : <div />}
            <RightContent>
                { (domain === 'pc'||domain === 'minishop') && <EstimateSave /> }
                <Share />
            </RightContent>
        </Style>
    )
}

const Style = styled.div`
    display: flex;
    justify-content: space-between;
`
const RightContent = styled.div`
    display: flex;
`

export default Top



// WEBPACK FOOTER //
// ./src/estimate_list/pages/index/components/top.jsx